(() => {
  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const cartBtn = root.querySelector('[data-yh-sticky-cart]');
    const countEl = root.querySelector('[data-yh-sticky-count]');
    const configured = (root.dataset.observe || '').split(',').map((s) => s.trim()).filter(Boolean);

    let pastHero = false;
    let nearFooter = false;
    let hideTimer = null;
    let heroEl = null;
    let footerEl = null;

    const findHero = () => {
      for (const sel of configured) {
        try {
          const el = document.querySelector(sel);
          if (el) return el;
        } catch (_) {
          /* ignore invalid selectors */
        }
      }
      return (
        document.querySelector('.shopify-section .slideshow')?.closest('.shopify-section') ||
        document.querySelector('#MainContent > .shopify-section')
      );
    };

    const findFooter = () => {
      const known =
        document.querySelector('.shopify-section-group-footer-group') ||
        document.querySelector('#shopify-section-footer') ||
        document.querySelector('footer.footer') ||
        document.querySelector('.footer') ||
        document.querySelector('[id*="footer"]');
      if (known) return known;

      const sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section'));
      for (let i = sections.length - 1; i >= 0; i -= 1) {
        const section = sections[i];
        if (!section.classList.contains('section-sticky-mobile-cta')) return section;
      }
      return null;
    };

    const setVisible = (visible) => {
      clearTimeout(hideTimer);

      if (visible) {
        root.hidden = false;
        root.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => {
          root.classList.add('is-visible');
          document.body.classList.add('yh-sticky-cta-active');
        });
        return;
      }

      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('yh-sticky-cta-active');
      hideTimer = setTimeout(() => {
        if (!root.classList.contains('is-visible')) root.hidden = true;
      }, 320);
    };

    const measureNearFooter = () => {
      const viewH = window.innerHeight || 0;
      const docH = Math.max(
        document.documentElement?.scrollHeight || 0,
        document.body?.scrollHeight || 0
      );
      const scrollBottom = window.scrollY + viewH;

      // Always hide near absolute page end
      if (docH > 0 && scrollBottom >= docH - 100) return true;

      if (!footerEl) return false;
      const rect = footerEl.getBoundingClientRect();
      // Hide as soon as any part of the footer enters the viewport
      return rect.top < viewH - 8;
    };

    const measurePastHero = () => {
      if (!heroEl) {
        return window.scrollY > Math.min(window.innerHeight * 0.55, 420);
      }
      const rect = heroEl.getBoundingClientRect();
      // Past hero once most of it has scrolled above the fold
      return rect.bottom < window.innerHeight * 0.35;
    };

    const syncVisibility = () => {
      pastHero = measurePastHero();
      nearFooter = measureNearFooter();
      setVisible(pastHero && !nearFooter);
    };

    // Start hidden
    root.classList.remove('is-visible');
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('yh-sticky-cta-active');

    heroEl = findHero();
    footerEl = findFooter();

    let scrollTick = false;
    const onScrollOrResize = () => {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(() => {
        scrollTick = false;
        syncVisibility();
      });
    };

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

    if ('IntersectionObserver' in window) {
      if (heroEl) {
        const heroIo = new IntersectionObserver(() => syncVisibility(), {
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
        });
        heroIo.observe(heroEl);
      }

      if (footerEl) {
        const footerIo = new IntersectionObserver(() => syncVisibility(), {
          // Positive bottom margin = hide slightly before footer reaches the bottom edge
          rootMargin: '0px 0px 80px 0px',
          threshold: [0, 0.01, 0.05, 0.1, 0.25, 0.5, 1],
        });
        footerIo.observe(footerEl);
      }
    }

    syncVisibility();

    const updateCount = (count) => {
      if (!countEl) return;
      const n = Math.max(0, Number(count) || 0);
      countEl.textContent = String(n);
      countEl.classList.toggle('is-empty', n === 0);
      if (cartBtn) {
        const label = cartBtn.getAttribute('aria-label')?.replace(/\s*\(\d+\)\s*$/, '') || 'Cart';
        cartBtn.setAttribute('aria-label', n > 0 ? `${label} (${n})` : label);
      }
    };

    const refreshFromCart = () => {
      fetch(`${window.routes?.cart_url || '/cart'}.js`)
        .then((r) => r.json())
        .then((cart) => updateCount(cart.item_count))
        .catch(() => {});
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshFromCart);
    }
    document.addEventListener('cart:updated', refreshFromCart);

    cartBtn?.addEventListener('click', () => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(cartBtn);
        return;
      }
      const bubble = document.querySelector('#cart-icon-bubble');
      if (bubble) {
        bubble.click();
        return;
      }
      window.location.href = window.routes?.cart_url || '/cart';
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-yh-sticky-cta]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const el = event.target?.querySelector?.('[data-yh-sticky-cta]') || event.target;
    if (el?.matches?.('[data-yh-sticky-cta]')) {
      el.dataset.ready = 'false';
      init(el);
    }
  });
})();
